import { getZIndexProperty } from './ClassPropertiesUtilities.js';

export function getZIndexFromNode(node, defaultZIndex, extraAmount){
    if (node != null){
        var zIndices = getParents(node).map(mapParentZIndexToInt);
        
        var maxIndex = getMaxZIndex(zIndices);
        return maxIndex > 0 ? (maxIndex + extraAmount) : defaultZIndex;
    }
}

function getParents(node){
    return (node.parentElement ? getParents(node.parentElement) : []).concat([node]);
}

function mapParentZIndexToInt(parentElement){
    var index = getZIndexProperty(parentElement);

    return index === 'auto' ? 0 : parseInt(index);
}

function getMaxZIndex(zIndices){
    return Math.max(...zIndices);
}


// WEBPACK FOOTER //
// ./src/lib/CustomClassUtilities.js